import { ExtendedFieldTranslationKeys } from 'intl/keys';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';
import { fieldValueEntityNames } from 'shared/domain/fieldValue/fieldValueClients';
import { FieldValuesResult, useFieldValues } from 'store/fieldValue';

export interface CustomizedFieldDefinition {
  fieldName: EditableFieldValuesEntityName;
  fieldLabelId: string;
  useFieldValues: () => FieldValuesResult;
}

const fieldLabelIds: Record<EditableFieldValuesEntityName, string> = {
  [EditableFieldValuesEntityName.workTypes]: ExtendedFieldTranslationKeys.workType,
  [EditableFieldValuesEntityName.hazardCategory]: ExtendedFieldTranslationKeys.hazardCategory,
  [EditableFieldValuesEntityName.environmentalAspect]: ExtendedFieldTranslationKeys.environmentalAspectCategory,
  [EditableFieldValuesEntityName.proposedCorrectiveAction]: ExtendedFieldTranslationKeys.proposedCorrectiveAction,
  [EditableFieldValuesEntityName.delayReason]: ExtendedFieldTranslationKeys.delayReason,
  [EditableFieldValuesEntityName.rejectionReason]: ExtendedFieldTranslationKeys.rejectionReason,
  [EditableFieldValuesEntityName.issueVerificationItem]: ExtendedFieldTranslationKeys.issueVerification,
  [EditableFieldValuesEntityName.rootCauses]: ExtendedFieldTranslationKeys.rootCause,
  [EditableFieldValuesEntityName.effect]: ExtendedFieldTranslationKeys.effect,
  [EditableFieldValuesEntityName.circumstances]: ExtendedFieldTranslationKeys.circumstances,
  [EditableFieldValuesEntityName.impact]: ExtendedFieldTranslationKeys.impact,
  [EditableFieldValuesEntityName.priority]: ExtendedFieldTranslationKeys.priority,
  [EditableFieldValuesEntityName.projectStage]: ExtendedFieldTranslationKeys.projectStage,
  [EditableFieldValuesEntityName.decisionToImposeFine]: ExtendedFieldTranslationKeys.decisionToImposeAFine,
  [EditableFieldValuesEntityName.spilledSubstance]: ExtendedFieldTranslationKeys.extendedfieldSpilledSubstance,
  [EditableFieldValuesEntityName.employmentType]: ExtendedFieldTranslationKeys.employmentType,
  [EditableFieldValuesEntityName.injuryType]: ExtendedFieldTranslationKeys.injuryTypes,
  [EditableFieldValuesEntityName.injuredBodyPart]: ExtendedFieldTranslationKeys.injuredBodyParts,
  [EditableFieldValuesEntityName.requirements]: ExtendedFieldTranslationKeys.requirements,
  [EditableFieldValuesEntityName.installationBasis]: ExtendedFieldTranslationKeys.installationBasis,
  [EditableFieldValuesEntityName.constructionProductDocuments]: ExtendedFieldTranslationKeys.constructionProductDocuments,
  [EditableFieldValuesEntityName.deviceDocuments]: ExtendedFieldTranslationKeys.deviceDocuments,
  [EditableFieldValuesEntityName.additionalDocuments]: ExtendedFieldTranslationKeys.additionalDocuments,
};

/** Every field whose values are configurable in the field settings. */
export const customizedFields = Object.fromEntries(
  fieldValueEntityNames.map((fieldName) => [
    fieldName,
    {
      fieldName,
      fieldLabelId: fieldLabelIds[fieldName],
      useFieldValues: (): FieldValuesResult => useFieldValues(fieldName),
    },
  ])
) as Record<EditableFieldValuesEntityName, CustomizedFieldDefinition>;
